import gql from 'graphql-tag';

export const CREATE_TAXI = gql`
mutation CreateTaxi($modelo: String! $marca: String! $matricula: String! $cantPasajeros: Int!){
 createTaxi(input: { modelo:$modelo marca:$marca matricula:$matricula cantPasajeros:$cantPasajeros}) {
  taxi{ 
   id
   modelo
   marca
   matricula
   cantPasajeros
  }
}
}
`;

export const UPDATE_TAXI = gql`
mutation UpdateTaxi($id: ID! $modelo: String! $marca: String! $matricula: String! $cantPasajeros: Int!){
 updateTaxi(id:$id input: { modelo:$modelo marca:$marca matricula:$matricula cantPasajeros:$cantPasajeros }) {
  taxi{
    id
    modelo
    marca
    matricula
    cantPasajeros
  }
}
}
`;

export const DELETE_TAXI = gql`
mutation DeleteTaxi($id: ID!){
deleteTaxi(id:$id) {
  found
}
}
`;
